import {
    Switch,
    Route,
} from "react-router-dom";
import { QueryClient, QueryClientProvider, useQuery } from "react-query";

import { LayoutComponent } from "./components";
import Dashboard from "./pages";
import Events from "./pages/events";
import Transactions from "./pages/transactions";
import Users from "./pages/users";
import AddEvents from "./pages/addEvents";
import EditEvents from "./pages/editEvent";
import EditUser from "./pages/editUser";
import routes from "./routes/routes";
import AddMember from "./pages/addUser";
import MessageMember from "./pages/messageMember";
import Profile from "./pages/profile";
import AddSection from "./pages/addSection";
import Sections from "./pages/sections";
import EditSections from "./pages/editSection";
import MessageSectionMember from "./pages/communications/section";
import Login from "./pages/login";
import EVoting from "./pages/eVoting";

const queryClient = new QueryClient();
function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <Switch>
                <Route exact path={routes.public.login} component={Login} />
                <LayoutComponent>
                    <Route exact path={routes.public.home} component={Dashboard} />
                    <Route exact path={routes.public.users} component={Users} />
                    <Route exact path={routes.public.createUser} component={AddMember} />
                    <Route exact path={routes.public.messageMember} component={MessageMember} />
                    <Route exact path={routes.public.messageSectionMember} component={MessageSectionMember} />
                    <Route exact path={routes.public.events} component={Events} />
                    <Route exact path={routes.public.editEvent} component={EditEvents} />
                    <Route exact path={routes.public.addEvent} component={AddEvents} />
                    <Route exact path={routes.public.editUser} component={EditUser} />
                    <Route exact path={routes.public.profile} component={Profile} />
                    <Route exact path={routes.public.eVoting} component={EVoting} />

                    <Route exact path={routes.public.addSection} component={AddSection} />
                    <Route exact path={routes.public.editSection} component={EditSections} />
                    <Route exact path={routes.public.sections} component={Sections} />
                    <Route exact path={routes.public.transactions} component={Transactions} />

                </LayoutComponent>
            </Switch>
        </QueryClientProvider>
    );
}

export default App;
